<template>
    <v-card v-if="typeof data != 'undefined'" flat style="width:100%;">
        <v-card-title primary class="title" style="height:50px;">{{data.title}} {{data.unit}}</v-card-title>
        <v-card-actions fill-height style="padding:0px;">
            <dx-circular-gauge ref="chart" style="width:100%;height:100%;" :value="data.value" :redraw-on-resize="true">
                <DxSize v-if="height" :height="height" />
                <dx-value-indicator spindleGapSize=60 type="rectangleNeedle" width=2 spindleSize=65 offset=7 />
                <dx-geometry :start-angle="225" :end-angle="315" />
                <dx-scale :start-value="data.startValue" :end-value="data.endValue" :custom-ticks="data.customTicks">
                    <dx-label :use-range-colors="true" />
                    <dx-tick :length="15" />
                </dx-scale>
                <dx-range-container :width="15" background-color="transparent">
                    <dx-range :start-value="data.startValue" :end-value="data.rangeLimit" color= "rgb(60, 171, 48)"/>
                    <dx-range :start-value="data.rangeLimit" :end-value="data.endValue" color="rgb(205, 57, 64)"/>
                </dx-range-container>
            </dx-circular-gauge>
            <span v-if="data.value!=-1000" class="gaugeTitle" :style="'font-size: 22px;top:'+(65+height/2)+'px;'"> {{data.value.toFixed(1)}} </span>
            <span v-else class="gaugeTitle" :style="'font-size: 22px;'"> - </span>
        </v-card-actions>
    </v-card>
</template>

<script>

    import {
        DxCircularGauge,
        DxSize,
        DxValueIndicator,
        DxGeometry,
        DxScale,
        DxRangeContainer,
        DxRange,
        DxTitle,
        DxFont,
        DxLabel,
        DxTick,
        DxSubvalueIndicator,
        DxText
    } from "devextreme-vue/circular-gauge";

    export default {
        name: 'Gauge',
        components: {
            DxCircularGauge,
            DxSize,
            DxValueIndicator,
            DxGeometry,
            DxScale,
            DxRangeContainer,
            DxRange,
            DxLabel,
            DxTick,
            DxTitle,
            DxFont,
            DxSubvalueIndicator,
            DxText
        },
        props: {
            data: Object,
            height: Number,
        },
        data() {
            return {}
        },
        computed: {},
        watch: {},
        methods: {
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .gaugeTitle {
        margin: 0;
        position: absolute;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        color: rgb(33, 33, 33);
        background-color: transparent;
    }
</style>